

import { useTranslation } from "react-i18next";
import ReactDOM from 'react-dom/client';

import { Link as LinkScroll, animateScroll as scroll, scroller } from "react-scroll";

import React, { useState, useEffect, useRef } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useLocation,
    useNavigate
} from "react-router-dom";


import TitleName from '../../../compontents/TitleName.js'
import TitleName2 from '../../../compontents/TitleName2.js'

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';



import { useSelector } from "react-redux";
import { useGlobalFunc } from "../../../global/constants.js";




const MemberCenterNavBar = () => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate()
    const query = new URLSearchParams(location.search);
    const userInfo = useSelector(state => state.userInfo);
    const {updateMe} = useGlobalFunc()

    const banner = []
    const [functionIndex, setFunctionIndex] = useState(-1)
    const countRef = useRef()

    const [functionList, setFunctionList] =  useState(["userinfo", "userGrade", "message", "usercollar", "negotiation", 'negotiationdispatch', "orderrecord", "event",
        //"recommend",
        "team",'changepw'])



    const [currentPathName, setCurrentPathName] = useState('');

    const handleChange = (event) => {
        navigate(`/membercenter/${functionList[event.target.value]}`)
        setFunctionIndex(event.target.value);

    };

    // orderRecord, registerPlace, successOrder, artCert, applyFunction, monthlySystem, myFavor, setting


    // applyFunction 申請功能
    // 鑑價申請 appraisalApply
    // 委託申請 commissionedApply
    // 藝品NFT憑證轉移 transferNFT
    // 回購申請 buyBackApply






    const [FAQType, setFAQType] = useState(0);

    useEffect(() => {
        
        if (userInfo == null) {
            return
        }
        // if (userInfo.identity.name == 'large' || userInfo.identity.name == 'quasi-large') {
        //     setFunctionList(["userinfo", "userGrade", "message", "usercollar", "negotiation", 'negotiationdispatch', "orderrecord", "event", "team",'changepw'])
        // }
        // else {
        //     setFunctionList(["userinfo", "userGrade", "message", "usercollar", "negotiation", 'negotiationdispatch', "orderrecord", "team",'changepw'])
        // }
    }, [userInfo])


    useEffect(() => {
        if (userInfo == null) {
            return
        }

        let temp = []
        if (userInfo.identity.name == 'large' || userInfo.identity.name == 'quasi-large') {
            temp = ["userinfo", "userGrade", "message", "usercollar", "negotiation", 'negotiationdispatch', "orderrecord", "event", "team",'changepw']
            setFunctionList(temp)
        }
        else {
            temp = ["userinfo", "userGrade", "message", "usercollar", "negotiation", 'negotiationdispatch', "orderrecord", "team",'changepw']
            setFunctionList(temp)
        }

        let pathname = location.pathname.substring(location.pathname.lastIndexOf('/') + 1)

        if (location.pathname.includes('event')) {
            setFunctionIndex(7)
            return
        }
        if (location.pathname.includes('negotiationdispatch')) {
            setFunctionIndex(5)
            return
        }
        if (location.pathname.includes('negotiation')) {
            setFunctionIndex(4)
            return
        }
        if (location.pathname.includes('order')) {
            setFunctionIndex(6)
            return
        }


        let typeIndex = functionList.indexOf(pathname)
        if (typeIndex != -1) {
            setFunctionIndex(typeIndex)
            console.log(typeIndex)
        }



    }, [userInfo]);

    useEffect(() => {

        if (!localStorage.getItem('userToken')) {
            navigate('/login')
        }
        else{
            updateMe()
        }


    }, [location.pathname]);




    return <div className="pb-4" >


        <div className="text-black text-3xl">會員中心</div>



        <div className="relative w-full  pt-14">


            <div className="hidden lg:flex flex-wrap gap-3 flex-none w-full   ">

                {
                    functionList.map((i, index) => <div className={`  font-bold text-base `} key={i}>
                        <button onClick={() => navigate(`/membercenter/${functionList[index]}`)} className={`${index == functionIndex ? "bg-red1 text-white" : "bg-white text-red1  "} shadow-xl px-4 py-2 rounded-lg`}>{t(`memberCenterType.${i}`)}</button>
                    </div>)
                }

            </div>
            <div className=" lg:hidden  text-black">

                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={functionIndex}
                    label=""
                    className="w-full"
                    onChange={handleChange}
                >
                    {
                        functionList.map((i, index) =>
                            <MenuItem key={i} value={index}>{t(`memberCenterType.${i}`)}</MenuItem>
                        )
                    }
                </Select>

            </div>


            <div className="hidden w-full grow ">
                <TitleName2 title1={t(`memberCenterType.${functionList[functionIndex]}`)} />

            </div>

        </div>




    </div >
}

export default MemberCenterNavBar